
import { Navigate, useLocation } from "react-router-dom";
import { useUnifiedAuth } from "@/contexts/UnifiedAuthContext";
import { ReactNode } from "react";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, status, isInitialized, isAuthenticating } = useUnifiedAuth();
  const location = useLocation();

  const isLoading = status === "loading" || !isInitialized || isAuthenticating;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-brand-500 rounded-full border-t-transparent"></div>
      </div>
    );
  }

  if (status === "unauthenticated") {
    // Сохранить полный путь (pathname + search + hash)
    const intendedPath = location.pathname + location.search + location.hash;

    // Не сохраняем "/" чтобы избежать лишних редиректов
    if (intendedPath !== '/' && intendedPath !== '') {
      localStorage.setItem('returnTo', intendedPath);
      console.log('[ProtectedRoute] Saved returnTo:', intendedPath);
    }

    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
